import { attr } from '@ember-data/model';

export default function arrayAttr() {
  return attr({ defaultValue: () => [], embedded: true })(...arguments);
}
